import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

/**
 * First / M.I. / Last name inputs with browser-autofill attributes.
 * Phones & browsers autofill from saved contact info via the autocomplete tokens.
 */
export default function NameFields({ first, mi, last, onChange, testidPrefix = "name", section, required = true }) {
    const ac = (token) => (section ? `section-${section} ${token}` : token);
    return (
        <div className="grid grid-cols-12 gap-3" data-testid={`${testidPrefix}-fields`}>
            <div className="col-span-6 sm:col-span-6">
                <Label className="text-[10px] uppercase tracking-[0.2em] text-[#a0a0a0]">First{required ? "" : " (optional)"}</Label>
                <Input
                    data-testid={`${testidPrefix}-first`}
                    autoComplete={ac("given-name")}
                    name="given-name"
                    value={first}
                    onChange={(e) => onChange({ first_name: e.target.value })}
                    className="mt-1.5 h-11 rounded-none bg-[#0f0f0f] border-[#2a2a2a]"
                />
            </div>
            <div className="col-span-2 sm:col-span-2">
                <Label className="text-[10px] uppercase tracking-[0.2em] text-[#a0a0a0]">M.I.</Label>
                <Input
                    data-testid={`${testidPrefix}-mi`}
                    autoComplete={ac("additional-name")}
                    name="additional-name"
                    maxLength={1}
                    placeholder="—"
                    value={mi}
                    onChange={(e) => onChange({ middle_initial: e.target.value.replace(/[^a-zA-Z]/g, "").slice(0, 1).toUpperCase() })}
                    className="mt-1.5 h-11 rounded-none bg-[#0f0f0f] border-[#2a2a2a] text-center"
                />
            </div>
            <div className="col-span-4 sm:col-span-4">
                <Label className="text-[10px] uppercase tracking-[0.2em] text-[#a0a0a0]">Last{required ? "" : " (optional)"}</Label>
                <Input
                    data-testid={`${testidPrefix}-last`}
                    autoComplete={ac("family-name")}
                    name="family-name"
                    value={last}
                    onChange={(e) => onChange({ last_name: e.target.value })}
                    className="mt-1.5 h-11 rounded-none bg-[#0f0f0f] border-[#2a2a2a]"
                />
            </div>
        </div>
    );
}

// Split a legacy single "name" string into first / mi / last.
export function splitName(full) {
    const parts = (full || "").trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return { first_name: "", middle_initial: "", last_name: "" };
    if (parts.length === 1) return { first_name: parts[0], middle_initial: "", last_name: "" };
    let mi = "";
    let rest = parts.slice(1);
    // Middle token like "M" or "M." → treat as initial
    if (rest.length > 1 && /^[A-Za-z]\.?$/.test(rest[0])) {
        mi = rest[0].replace(".", "").toUpperCase();
        rest = rest.slice(1);
    }
    return { first_name: parts[0], middle_initial: mi, last_name: rest.join(" ") };
}
